module.exports = __webpack_public_path__ + "img/9.6.CODm.0933eab5.png";